import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _client, _observers, _mutationCache, _retryer, _dispatch;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/mutation.ts
import { notifyManager } from "./notifyManager.js";
import { Removable } from "./removable.js";
import { createRetryer } from "./retryer.js";
var Mutation = (_client = /*#__PURE__*/_classPrivateFieldLooseKey("client"), _observers = /*#__PURE__*/_classPrivateFieldLooseKey("observers"), _mutationCache = /*#__PURE__*/_classPrivateFieldLooseKey("mutationCache"), _retryer = /*#__PURE__*/_classPrivateFieldLooseKey("retryer"), _dispatch = /*#__PURE__*/_classPrivateFieldLooseKey("dispatch"), class Mutation extends Removable {
  constructor(config) {
    super();
    Object.defineProperty(this, _dispatch, {
      value: _dispatch2
    });
    Object.defineProperty(this, _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _observers, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _mutationCache, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryer, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _client)[_client] = config.client;
    this.mutationId = config.mutationId;
    _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache] = config.mutationCache;
    _classPrivateFieldLooseBase(this, _observers)[_observers] = [];
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = options;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!_classPrivateFieldLooseBase(this, _observers)[_observers].includes(observer)) {
      _classPrivateFieldLooseBase(this, _observers)[_observers].push(observer);
      this.clearGcTimeout();
      _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    _classPrivateFieldLooseBase(this, _observers)[_observers] = _classPrivateFieldLooseBase(this, _observers)[_observers].filter(x => x !== observer);
    this.scheduleGc();
    _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!_classPrivateFieldLooseBase(this, _observers)[_observers].length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].remove(this);
      }
    }
  }
  continue() {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    return (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _retryer)[_retryer]) === null || _classPrivateFieldLoo2 === void 0 ? void 0 : _classPrivateFieldLoo2.continue()) !== null && _classPrivateFieldLoo !== void 0 ? _classPrivateFieldLoo :
    // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(variables) {
    var _this$options$retry;
    const onContinue = () => {
      _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
        type: "continue"
      });
    };
    const mutationFnContext = {
      client: _classPrivateFieldLooseBase(this, _client)[_client],
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    _classPrivateFieldLooseBase(this, _retryer)[_retryer] = createRetryer({
      fn: () => {
        if (!this.options.mutationFn) {
          return Promise.reject(new Error("No mutationFn found"));
        }
        return this.options.mutationFn(variables, mutationFnContext);
      },
      onFail: (failureCount, error) => {
        _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
          type: "failed",
          failureCount,
          error
        });
      },
      onPause: () => {
        _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
          type: "pause"
        });
      },
      onContinue,
      retry: (_this$options$retry = this.options.retry) !== null && _this$options$retry !== void 0 ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].canRun(this)
    });
    const restored = this.state.status === "pending";
    const isPaused = !_classPrivateFieldLooseBase(this, _retryer)[_retryer].canStart();
    try {
      var _classPrivateFieldLoo5, _classPrivateFieldLoo6, _this$options$onSucce, _this$options2, _classPrivateFieldLoo7, _classPrivateFieldLoo8, _this$options$onSettl, _this$options3;
      if (restored) {
        onContinue();
      } else {
        var _classPrivateFieldLoo3, _classPrivateFieldLoo4, _this$options$onMutat, _this$options;
        _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
          type: "pending",
          variables,
          isPaused
        });
        await ((_classPrivateFieldLoo3 = (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].config).onMutate) === null || _classPrivateFieldLoo3 === void 0 ? void 0 : _classPrivateFieldLoo3.call(_classPrivateFieldLoo4, variables, this, mutationFnContext));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables, mutationFnContext));
        if (context !== this.state.context) {
          _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
            type: "pending",
            context,
            variables,
            isPaused
          });
        }
      }
      const data = await _classPrivateFieldLooseBase(this, _retryer)[_retryer].start();
      await ((_classPrivateFieldLoo5 = (_classPrivateFieldLoo6 = _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].config).onSuccess) === null || _classPrivateFieldLoo5 === void 0 ? void 0 : _classPrivateFieldLoo5.call(_classPrivateFieldLoo6, data, variables, this.state.context, this, mutationFnContext));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context, mutationFnContext));
      await ((_classPrivateFieldLoo7 = (_classPrivateFieldLoo8 = _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].config).onSettled) === null || _classPrivateFieldLoo7 === void 0 ? void 0 : _classPrivateFieldLoo7.call(_classPrivateFieldLoo8, data, null, this.state.variables, this.state.context, this, mutationFnContext));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context, mutationFnContext));
      _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
        type: "success",
        data
      });
      return data;
    } catch (error) {
      try {
        var _classPrivateFieldLoo9, _classPrivateFieldLoo0, _this$options$onError, _this$options4, _classPrivateFieldLoo1, _classPrivateFieldLoo10, _this$options$onSettl2, _this$options5;
        await ((_classPrivateFieldLoo9 = (_classPrivateFieldLoo0 = _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].config).onError) === null || _classPrivateFieldLoo9 === void 0 ? void 0 : _classPrivateFieldLoo9.call(_classPrivateFieldLoo0, error, variables, this.state.context, this, mutationFnContext));
        await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context, mutationFnContext));
        await ((_classPrivateFieldLoo1 = (_classPrivateFieldLoo10 = _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].config).onSettled) === null || _classPrivateFieldLoo1 === void 0 ? void 0 : _classPrivateFieldLoo1.call(_classPrivateFieldLoo10, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context, mutationFnContext));
        throw error;
      } finally {
        _classPrivateFieldLooseBase(this, _dispatch)[_dispatch]({
          type: "error",
          error
        });
      }
    } finally {
      _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].runNext(this);
    }
  }
});
function _dispatch2(action) {
  const reducer = state => {
    switch (action.type) {
      case "failed":
        return _objectSpread(_objectSpread({}, state), {}, {
          failureCount: action.failureCount,
          failureReason: action.error
        });
      case "pause":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: true
        });
      case "continue":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: false
        });
      case "pending":
        return _objectSpread(_objectSpread({}, state), {}, {
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        });
      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        });
      case "error":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        });
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    _classPrivateFieldLooseBase(this, _observers)[_observers].forEach(observer => {
      observer.onMutationUpdate(action);
    });
    _classPrivateFieldLooseBase(this, _mutationCache)[_mutationCache].notify({
      mutation: this,
      type: "updated",
      action
    });
  });
}
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
export { Mutation, getDefaultState };